// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HOyE","content":"styles_content__hc4EG"};